export { getAiAgentWsUrl } from "./aiAgentConfig";
export { createAgentSession } from "./aiAgentSession";
export { AiAgentStateReader } from "./aiAgentStateReader";
export { pressKey, pressLane, pressSpace } from "./aiAgentKeyInjector";
export { AiAgentSocket } from "./aiAgentSocket";

import { createAgentSession } from "./aiAgentSession";
import { AiAgentStateReader } from "./aiAgentStateReader";
import { pressKey, pressLane, pressSpace } from "./aiAgentKeyInjector";
import { AiAgentSocket } from "./aiAgentSocket";

/** Exposes the devtools handle - not gated, only launchAgentSession() actually starts anything. */
export function enableAiAgentInterface() {
  const handle = { launchAgentSession, pressKey, pressLane, pressSpace };
  if (typeof window !== "undefined") window.__gearshiftAiAgent = handle;
  return handle;
}

/**
 * Launches an unclaimed agent session, state reader, and WebSocket
 * connection. Identity is declared by the agent repo in session.ready, not
 * passed in here.
 * @param {{wsUrl?: string, connectSocket?: boolean}} [options]
 */
export function launchAgentSession({ wsUrl, connectSocket = true } = {}) {
  const session = createAgentSession();
  const stateReader = new AiAgentStateReader({ session });
  stateReader.start();

  const boundPressKey = (code, options) => pressKey(code, { ...options, session });
  const boundPressLane = (lane, options) => pressLane(lane, { ...options, session });
  const boundPressSpace = (options) => pressSpace({ ...options, session });

  const socket = new AiAgentSocket({
    session,
    stateReader,
    pressLane: boundPressLane,
    pressKey: boundPressKey,
    wsUrl,
  });
  if (connectSocket) socket.connect();

  const handle = {
    session,
    stateReader,
    socket,
    pressKey: boundPressKey,
    pressLane: boundPressLane,
    pressSpace: boundPressSpace,
  };
  if (typeof window !== "undefined") {
    window.__gearshiftAiAgent = { ...window.__gearshiftAiAgent, ...handle };
  }
  return handle;
}
